export const setConfigChartFilterBox = (data: any) => {
  // dummy data when raw.data is empty
  // data = { ...data, data: [] };
  Object.keys(data.data).forEach((key) => {
    data.data[key].forEach((item: any) => {
      if (!item.id && !item.text) {
        (item.id = null), (item.text = '[NULL]');
      }
    });
  });

  let options = {
    data: data.data,
  };
  return options;
};

export const alphabeth = [
  ['a', 'A'],
  ['b', 'B'],
  ['c', 'C'],
  ['d', 'D'],
  ['e', 'E'],
  ['f', 'F'],
  ['g', 'G'],
  ['h', 'H'],
  ['i', 'I'],
  ['j', 'J'],
  ['k', 'K'],
  ['l', 'L'],
  ['m', 'M'],
  ['n', 'N'],
  ['o', 'O'],
  ['p', 'P'],
  ['q', 'Q'],
  ['r', 'R'],
  ['s', 'S'],
  ['t', 'T'],
  ['u', 'U'],
  ['v', 'V'],
  ['w', 'W'],
  ['x', 'X'],
  ['y', 'Y'],
  ['z', 'Z'],
];
